import React, {PureComponent} from 'react'
import {Router, Switch} from 'react-router-dom'
import {BrowserRouter} from 'react-router-dom'
import {Provider} from 'mobx-react'
import cxs from 'cxs/component'
import {opacity} from 'helpers/Colors'
import Store from './Store'
import Theme from './Theme'
import history from 'helpers/History'
import Main from 'scenes/Main'
import Login from 'scenes/Login'
import Recovery from 'scenes/Recovery'
import {Route, UIMessage} from 'components'
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
/*import 'flag-icon-css/css/flag-icon.min.css';*/
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.css'
export const store = new Store()

class App extends PureComponent {
  render() {
    return (
      <Router history={history}>
        <Provider store={store}>
          <Wrapper>
            <UIMessage />
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/recovery" component={Recovery} />
              <Route path="/" component={Main} auth />
              <Route render={() => <p>404</p>} />
            </Switch>
          </Wrapper>
        </Provider>
      </Router>
    )
  }
}

export default App

const Wrapper = cxs('div')({
  display: 'flex',
  height: '100%',
  fontSize: Theme.fontSize.regular,
  fontFamily: Theme.fontFamily,
  fontWeight: Theme.fontWeight,
  lineHeight: Theme.lineHeight,
  color: Theme.color.secondary,
  textTransform: 'capitalize',
  '-webkit-tap-highlight-color': opacity(0.25, Theme.color.primary)
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx